import { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { trackPageView, setUsageEnabled } from '../services/usage'

/** Reports every route change as a page_view usage event for logged-in users. Renders nothing. */
const UsageTracker = ({ location, isLoggedIn }) => {
  useEffect(() => {
    setUsageEnabled(isLoggedIn)
  }, [isLoggedIn])

  useEffect(() => {
    if (isLoggedIn) trackPageView(location.pathname)
  }, [location.pathname, isLoggedIn])

  return null
}

const mapStateToProps = state => ({ isLoggedIn: !!(state.user && state.user.isLoggedIn) })

export default connect(mapStateToProps)(withRouter(UsageTracker))
